import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './PokemonMarkerPopup.module.css';
import Directions from "../Directions";
import forms from "../../../utils/forms";
import {formatTime, getIv} from "../../../utils";



const PokemonMarkerPopup = (props) => {
	navigator.clipboard && navigator.clipboard.writeText(props.pokemon.latitude + ", " + props.pokemon.longitude);

	let form = null;
	if( props.pokemon.form ) {
		const pokemonForms = forms[props.pokemon.pokemon_id];
		form = <div	className={css.FormsLine}>{pokemonForms && pokemonForms[props.pokemon.form] ? pokemonForms[props.pokemon.form] + ' form' : 'Special Form (' + props.pokemon.form + ")"}</div>;
	}
	// if( this.isWeatherBoosted() )
	// 	str += "<p><img src='/common/images/pokemon/weather/weather-" + window.weather[this.data['s2-10']] + ".png' width='32'> Weather Boosted</p>";

	return (<div className={css.RaidMarkerPopup}>
		<div className={css.HeaderLine}>
			{props.pokemon.name} Spawn
		</div>

		{form}

		{props.pokemon.weather_boosted_condition > 0 &&
		<div className={css.WeatherBoostLine}>
			<img alt='Weather Boost'
				 src={'https://www.a2pogo.com/common/images/pokemon/weather/weather-' + props.pokemon.weather_boosted_condition + '.png'} />
			Weather Boosted
		</div>
		}

		{props.pokemon.cp > 0 &&
			<div className={css.StatsLine}>
				CP {props.pokemon.cp} (Level {props.pokemon.level})<br />
				{getIv(props.pokemon)}% ({props.pokemon.iv_a}/{props.pokemon.iv_d}/{props.pokemon.iv_s} A/D/S)<br />
				{props.pokemon.move_1} / {props.pokemon.move_2}
			</div>
		}

		{props.isAdmin &&
			<div className={css.QualityLine}>
				Quality: <span>{props.pokemon.quality}</span>
			</div>
		}

		<div className={css.DespawnLine}>
			{props.pokemon.verified ? "Despawns at " + formatTime(new Date(props.pokemon.disappear_time * 1000)) : "Unknown despawn time, may already be gone."}
		</div>

		<Directions id={props.id} latitude={props.pokemon.latitude} longitude={props.pokemon.longitude} />
	</div>);
};

PokemonMarkerPopup.propTypes = {
	pokemon: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	return {
		weather: state.core.weather,
		moves: state.core.moves,
		isAdmin: state.core.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PokemonMarkerPopup);